import React, { lazy, Suspense } from 'react';

import { AtlassianRelayEnvironmentProvider } from '@atlassian/relay-environment-provider';

import type { InferredProjectPopupProps } from '../inferred-project-popup/inferred-project-popup';

const InferredProjectPopup = lazy(() =>
	import(
		/* webpackChunkName: "@atlaskit-internal_inferred-project-popup-dialog" */ '../inferred-project-popup/inferred-project-popup'
	).then((module) => ({ default: module.InferredProjectPopup })),
);
Object.assign(InferredProjectPopup, { displayName: 'lazy(InferredProjectPopup)' });

export type InferredProjectPopupContentProps = InferredProjectPopupProps;

/**
 * The inferred-project popup the For You suggested rows open. A product registers it through
 * `@atlassian/rovo-platform-ui-components/inferred-project-popup-content`; it brings its own Relay
 * environment, which the promotion hooks and the page share, and loads the dialog only once mounted.
 */
export const InferredProjectPopupContent = (
	props: InferredProjectPopupContentProps,
): React.JSX.Element => (
	<AtlassianRelayEnvironmentProvider>
		<Suspense fallback={null}>
			<InferredProjectPopup {...props} />
		</Suspense>
	</AtlassianRelayEnvironmentProvider>
);
